var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-carousel',{attrs:{"cycle":"","show-arrows-on-hover":"","hide-delimiter-background":"","hide-delimiters":"","progress":""}},_vm._l((_vm.slides),function(slide,i){return _c('v-carousel-item',{key:i,staticClass:"item"},[_c('img',{attrs:{"src":slide.imgSrc,"width":"100%"}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }